module.exports = __webpack_public_path__ + "img/20200514_145805.0495a807.jpg";